import { WaitLoadingService } from './../components/common/waitLoading/wait-loading.service';
import { Component, AfterContentInit, ElementRef, OnDestroy } from '@angular/core';
import { PlycaDataService } from '../../services/plyca.service';
import { TranslateService } from '@ngx-translate/core';
import { ReportDTO } from '../api/plyca-dtos-v2';
import { Configuration } from '../conf/app.constants';
import { UIService } from '../ui.service';
import { DomSanitizer } from '@angular/platform-browser';
import {
  ReportsConfComponent,
  ReportConfDTOModal
} from './reports-conf.component';
import { HelpService, HelpType } from '../components/common/help/help.service';

import { getSimpleIdentifierFromString } from '../api/plyca-dtos';
import { HeaderActionsService } from '../components/common/sub-header/header-actions.service';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { ConfirmationService } from 'primeng-lts/api';
import { ServiceLocator } from '../ServiceLocator';

@Component({
  selector: 'reports',
  templateUrl: 'reports.template.html'
})
export class ReportsComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  showHeader = true;
  loading = true;
  public reports: Array<ReportDTO>;
  public filteredReports: Array<ReportDTO>;
  public personalizedReports: Array<ReportDTO>;
  allowAddReport = true;

  public filterText = '';

  rowGroupMetadata: any;

  newWindow = false;
  displayDialog = false;
  dialogTitle = '';
  sanitizedURL: any;
  selectedReport: ReportDTO;

  constructor(
    //    private route: ActivatedRoute,
    public helpService: HelpService,
    public configuration: Configuration,
    public plycaService: PlycaDataService,
    public translate: TranslateService,
    public uiService: UIService,
    public sanitizer: DomSanitizer,
    public dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    private waitService: WaitLoadingService
  ) {
    super();
  }

  ngAfterContentInit(): void {
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.REPORT));
    this.headerActionsService.setTaskDescription(
      this.elem,
      'General.reports',
      'fas fa-database',
      true
    );
    this.getPropertyCreateReport();
    this.loadReports();
  }

  ngOnDestroy(): void {
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  isLoading() {
    return this.loading;
  }

  getPropertyCreateReport() { }

  loadReports() {
    this.waitService.startWaiting();
    this.loading = true;
    this.subscribe(this.plycaService
      .query<any>(this.configuration.REPORTS_SERVICE_URL),
      resp => {
        if (resp && resp.content) {
          this.reports = resp.content;
          // ordenar los informres por grupo
          this.reports.sort((a, b) =>
            a.group < b.group ? -1 : a.group > b.group ? 1 : 0
          );
          this.personalizedReports = this.reports.filter(
            report =>
              report.reportingType && getSimpleIdentifierFromString(report.reportingType.identifier) ===
              '1'
          );
          this.reports = this.reports.filter(
            report =>
              report.reportingType && getSimpleIdentifierFromString(report.reportingType.identifier) !==
              '1'
          );

          //          this.updateRowGroupMetaData();
          this.updateFilter();
        } else {
          this.reports = [];
        }
        this.createButtonHeader();
        this.loading = false;
        this.waitService.cancelWaiting();
      });
  }

  createButtonHeader() {
    this.headerActionsService.clearActions();
    this.subscribe(this.headerActionsService
      .addAction('General.reload', 'fas fa-sync-alt', 'btn-secondary', true),
      success => {
        this.loadReports();
      });
    this.subscribe(this.headerActionsService
      .addAction(
        'Report.register',
        'fas fa-plus',
        'btn-primary',
        function () {
          return this.allowAddReport;
        }.bind(this)
      ),
      success => {
        this.registerReport(null);
      });
    if (this.personalizedReports) {
      for (let i = 0; i < this.personalizedReports.length; i++) {
        let reportButton = this.personalizedReports[i];
        this.subscribe(this.headerActionsService
          .addAction(
            reportButton.name,
            'fas fa-chevron-left',
            'btn-secondary',
            true
          ),
          success => {
            this.openReport(reportButton);
          });
      }
    }
    this.headerActionsService.addDivider();
    this.subscribe(this.headerActionsService
      .addAction(
        'General.back',
        'fas fa-chevron-left',
        'btn-outline-secondary',
        function () {
          return !this.isLoading();
        }.bind(this)
      ),
      success => {
        this.uiService.routeBack();
      });
  }
  updateRowGroupMetaData() {
    this.rowGroupMetadata = {};
    if (this.filteredReports) {
      for (let i = 0; i < this.filteredReports.length; i++) {
        let rowData = this.filteredReports[i];
        let group = rowData.group;
        if (i === 0) {
          this.rowGroupMetadata[group] = { index: 0, size: 1 };
        } else {
          let previousRowData = this.filteredReports[i - 1];
          let previousRowGroup = previousRowData.group;
          if (group === previousRowGroup) {
            this.rowGroupMetadata[group].size++;
          } else {
            this.rowGroupMetadata[group] = { index: i, size: 1 };
          }
        }
      }
    }
  }

  public updateFilter() {
    this.filteredReports = [];
    if (this.reports) {
      let val: string = this.filterText;
      this.filteredReports = this.reports.filter(function (d: any) {
        let reportDesc = d.description;
        return (
          reportDesc.toLowerCase().indexOf(val.toLowerCase()) !== -1 || !val
        );
      });
      this.updateRowGroupMetaData();
    }
  }

  openReport(report: ReportDTO) {
    this.selectedReport = report;
    let reportURL = this.configuration.PLYCAJ2EE_URL + report.urlReport;
    // if (this.newWindow) {
    let locale = this.translate.currentLang;
    if (reportURL.indexOf('?') !== -1) {
      reportURL = reportURL + '&locale=' + locale;
    } else {
      reportURL = reportURL + '?locale=' + locale;
    }
    window.open(reportURL, '_blank');
    /*} else {
      this.sanitizedURL = this.sanitizer.bypassSecurityTrustResourceUrl(
        reportURL
      );
      this.displayDialog = true;
    }*/
  }

  registerReport(report: ReportDTO) {
    this.editReport();
  }

  editReport(report?: ReportDTO) {
    let context = new ReportConfDTOModal(report);
    let config: DynamicDialogConfig = {
      header: 'CONFIGURACION INFORMES',
      width: '80%',
      style: { overflow: 'hidden' }
    };
    console.log('OPENREPORT, CONTEXT', context);
    config['context'] = context;
    const dialog = this.dialogService.open(ReportsConfComponent, config);
    this.subscribe(dialog.onClose, newreport => {
      if (newreport) {
        this.loadReports();
      } else {
        console.log('dialog cancelado');
      }
    });
  }

  editReportPentaho(report?: ReportDTO) {
    let reportURL = this.configuration.PLYCAJ2EE_URL + report.urlReportEdition;
    window.open(reportURL, '_blank', 'fullscreen=yes');
  }

  delete(report: ReportDTO) {
    this.confirmationService.confirm({
      message:
        'Se va a eliminar el informe: ' +
        report.description +
        '. ¿Desea continuar?',
      accept: () => {
        this.subscribe(this.plycaService
          .delete<any>(
            this.configuration.REPORTS_SERVICE_URL,
            report.identifier
          ),
          resp => {
            this.loadReports();
          });
      }
    });
  }

  isEditing() {
    // Si el usuario tiene permisos para editar el informe
    return true;
  }
}
